import React, { FC } from 'react'
import IconSVG, { IconSVGProps } from '../IconSVG'

const IconChair: FC<IconSVGProps> = ({ ...props }) => (
  <IconSVG className="IconDoc" {...props}>
    <svg height="100%" width="32" viewBox="0 0 18 32" fill="currentColor">
      <path
        fillRule="evenodd"
        d="M1.61538.5c-.23953 0-.45264.0599-.62997.175792C.810668.78999.69963.939512.630595 1.07533c-.067912.13361-.09921.26129-.114323.35143-.007752.04624-.011787.08589-.013904.11599-.001064.01513-.001661.0281-.001989.03855l-.000317.01383-.000053.00548L.5 1.60377V32.3962c0 .2977.10357.5832.31906.7947.21464.2106.50091.3091.79632.3091.29542 0 .58169-.0985.79633-.3091.21549-.2115.31906-.497.31906-.7947v-7.7641H15.2692v7.7641c0 .2977.1036.5832.3191.7947.2146.2106.5009.3091.7963.3091s.5817-.0985.7963-.3091c.2155-.2115.3191-.497.3191-.7947V19.717c0-1.6134-1.3406-2.9151-2.9615-2.9151H2.73237V1.6h-.49964c.49964 0 .49964-.00078.49964-.00104v-.00109l-.00002-.00239-.00006-.00549-.00036-.01386c-.00036-.01045-.00099-.02342-.00211-.03854-.0022-.03007-.00636-.06966-.01427-.1158-.01542-.08998-.04718-.21729-.11563-.35042-.06961-.135378-.18114-.283901-.35584-.397165C2.06691.559348 1.85431.5 1.61538.5Zm1.11539 21.9245v-3.4151H14.5385c.4098 0 .7307.3285.7307.7076v2.7075H2.73077Z"
        clipRule="evenodd"
      />
    </svg>
  </IconSVG>
)

export default IconChair
